import React, { useEffect, useState } from "react";
import classes from "../style/Style.module.css";
import "../style/Infoscreens.scss"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DexterCall from "../Images/UpdatedDexter-call.svg";
import {
  ROUTE_ACCOUNT_TYPE,
  ROUTE_CHECKBOXES,
  Gender_Dob_Verification,
  Address_Verification,
  ROUTE_OCCUPATION,
  ROUTE_PLACEOF_BIRTH,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_NRI_Address,
  ROUTE_NOMINEE_DETAILS,
  ROUTE_NOMINEE_SENDOTP,
  ROUTE_DXTER_SCANNING,
} from "../Routes";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPanNumber } from "../Store/panNumberSlice";
import { ToastContainer } from "react-toastify";
import Toast from "../Components/ToastMsg/Toast";
import axios from "../libs/axiosConfig";
import { selectPhoneNumber } from "../Store/MobileSlice";
// import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../Images/NewDexterLogo.svg";
import LogoutModal from "../Components/LogoutModal";

const Email = () => {
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  // const refreshToken = useSelector(selectRefreshToken);
  const [showModal, setShowModal] = useState(false);

  const panNumber = useSelector(selectPanNumber);

  const Navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});
  const [email, setEmail] = useState("");
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleClearButtonClick = () => {
    setEmail("");
  };

  const validateEmailFormat = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(email);

    setFormErrors({
      ...formErrors,
      email: isValid ? "" : "Please enter a valid Email Id",
    });

    return isValid;
  };

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const HandleSubmit = async () => {
    if (!validateEmailFormat(email)) {
      setFormErrors({
        ...formErrors,
        email: "Please enter a valid Email Id",
      });
      Toast.error("Please enter a valid Email Id", "error");
      return;
    } else {
      setFormErrors({ ...formErrors, email: "" });
    }

    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      setApiCallsInProgress(apiCallsInProgress + 1);

      const dexterrResponse = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        {
          CustomerKycDetails: {
            request_type: "post",
            mobileNumber: phoneNumber,
            pan: panNumber,
            emailId: email,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            // RefreshToken: refreshToken
          },
        }
      );

      // Toast.success("Dexterr API call successful", "success");

      // const secondApiResponse = await axios.post(
      //   "https://partnerapp.ambrela.money/api/AddCustomerKycDetails",
      //   {
      //     emailId: email,
      //   },
      //   {
      //     headers: {
      //       Authorization: `Bearer ${storedToken}`,
      //       // RefreshToken: refreshToken
      //     },
      //   }
      // );

      if (dexterrResponse.data.statusCode === 200) {
        setApiCallsInProgress(apiCallsInProgress + 1);
        console.log("Second API call successful");
        // Toast.success("Second API call successful", "success");

        // Only make the third API call if the first two are successful
        const thirdApiResponse = await axios.post(
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
          {
            CustomerKycDetails: {
              request_type: "get",
              mobileNumber: phoneNumber,
              pan: panNumber,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
              // RefreshToken: refreshToken
            },
          }
        );

        // const customerKycApiResponse = await axios.get(
        //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",

        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken,
        //     },
        //   }
        // );

        if (
          thirdApiResponse.data.statusCode === 200 &&
          thirdApiResponse.data.status === true
        ) {
          setApiCallsInProgress(apiCallsInProgress - 1);

          if (
            thirdApiResponse.data.body.bankAccountNumber === "" ||
            thirdApiResponse.data.body.bankIfscCode === "" ||
            thirdApiResponse.data.body.bankAccountType === "" ||
            thirdApiResponse.data.body.bankName === "" ||
            thirdApiResponse.data.body.bankBranchName === "" ||
            thirdApiResponse.data.body.bankBranchAddress === "" ||
            thirdApiResponse.data.body.bankCodeNSE === "" ||
            thirdApiResponse.data.body.bankCodeBillDesk === "" ||
            thirdApiResponse.data.body.bankAccountHolderName === ""
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            (thirdApiResponse.data.body.bankAccountNumber !== "" ||
              thirdApiResponse.data.body.bankIfscCode !== "" ||
              thirdApiResponse.data.body.bankAccountType !== "" ||
              thirdApiResponse.data.body.bankName !== "" ||
              thirdApiResponse.data.body.bankBranchName !== "" ||
              thirdApiResponse.data.body.bankBranchAddress !== "" ||
              thirdApiResponse.data.body.bankCodeNSE !== "" ||
              thirdApiResponse.data.body.bankCodeBillDesk !== "" ||
              thirdApiResponse.data.body.bankAccountHolderName !== "" ||
              null) &&
            (thirdApiResponse.data.body.bankVerified.account_exists !==
              "True" ||
              thirdApiResponse.data.body.bankVerified.message !== "success")
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            thirdApiResponse.data.body.panDetails.gender === "" ||
            thirdApiResponse.data.body.panDetails.title === "" ||
            thirdApiResponse.data.body.panDetails.dob === ""
          ) {
            Navigate(Gender_Dob_Verification);
          } else if (
            thirdApiResponse.data.body.panDetails.addr1 === "" ||
            thirdApiResponse.data.body.panDetails.addr2 === "" ||
            thirdApiResponse.data.body.panDetails.city === "" ||
            thirdApiResponse.data.body.panDetails.state === "" ||
            thirdApiResponse.data.body.panDetails.pincode === "" ||
            thirdApiResponse.data.body.panDetails.country === "" ||
            thirdApiResponse.data.body.panDetails.fullAddress === ""
          ) {
            Navigate(Address_Verification);
          } else if (
            thirdApiResponse.data.body.nseIncomeCode === "" ||
            thirdApiResponse.data.body.nseIncomeCodeDescription === "" ||
            null ||
            thirdApiResponse.data.body.nseOccupationCode === "" ||
            thirdApiResponse.data.body.nseOccupationCodeDescription === "" ||
            null
          ) {
            Navigate(ROUTE_OCCUPATION);
          } else if (
            thirdApiResponse.data.body.placeOfBirth === "" ||
            thirdApiResponse.data.body.nseCountryCodeOfBirth === "" ||
            thirdApiResponse.data.body.nseCountryOfBirth === ""
          ) {
            Navigate(ROUTE_PLACEOF_BIRTH);
          } else if (
            thirdApiResponse.data.body.politicallyExposedPerson === "" ||
            thirdApiResponse.data.body.relatedToPoliticallyExposedPerson === ""
          ) {
            Navigate(ROUTE_CHECKBOXES);
          } else if (
            thirdApiResponse.data.body.nomineeDob !== "" &&
            thirdApiResponse.data.body.nomineeName === ""
          ) {
            Navigate(ROUTE_NOMINEE_DETAILS);
          } else if (
            thirdApiResponse.data.body.nomineeName !== "" &&
            thirdApiResponse.data.body.nomineeDob === ""
          ) {
            Navigate(ROUTE_NOMINEE_DETAILS);
          } else if (
            thirdApiResponse.data.body.nomineeName !== "" &&
            thirdApiResponse.data.body.nomineeType !== "" &&
            thirdApiResponse.data.body.nomineeRelationShip !== "" &&
            thirdApiResponse.data.body.nomineeDob !== "" &&
            thirdApiResponse.data.body.nomineeVerified === "N"
          ) {
            console.log("first");
            Navigate(ROUTE_NOMINEE_SENDOTP);
          }
          else {
            setApiCallsInProgress(apiCallsInProgress + 1);
            const requestBody = {
              dexterrCustomerBasicQuestions: {
                mobile_no: phoneNumber,
                request_type: "get",
                country_code: "+91",
              }
            };

            const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
              headers: headers
            });
            if (secondApiResponse.data.data.resident !== "Resident Indian") {
              Navigate(ROUTE_NRI_Address)
            }
            else {
              Navigate(ROUTE_DXTER_SCANNING);
            }
          }
          
          // Navigate(ROUTE_DXTER_SCANNING)
          console.log("Third API call successful");
          // Toast.success("Third API call successful", "success");
        }
        else {
          console.error("Third API call failed");
          Toast.error(
            thirdApiResponse.data.message +
            "" +
            thirdApiResponse.data.errorMessage
          );
          setApiCallsInProgress(apiCallsInProgress - 1);
        }
      } else {
        console.error("Second API call failed");
        Toast.error(
          dexterrResponse.data.message + " " + dexterrResponse.data.errorMessage
        );
        setApiCallsInProgress(apiCallsInProgress - 1);
      }
      setApiCallsInProgress(apiCallsInProgress - 1);
    } catch (error) {
      console.error("Error in API calls:", error);
      console.error("API Response:", error.response);
      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
        "Error"
      );
    }
  };

  return (
    <div className="Email_Main_Container">
      <div className="Email_container_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="Email_Verification_Container">
        <p className="Input_Heading_text">Enter your email</p>
        <span className="Input_Sub_heading">
          Set up your account and complete your KYC verification..
        </span>
        <div className="Input_Filed_Box">
          <span className="Enter_email_text">Enter your email</span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.email ? classes.Error : ""
                }`}
              value={email}
              onChange={handleInputChange}
              placeholder="xyz@gmail.com"
            />
            <button
              className={classes.Cross_button}
              onClick={handleClearButtonClick}
            />
          </div>
        </div>
        <button className="Submit_button" onClick={HandleSubmit}>
          Submit
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
    </div>
  );
};

export default Email;
